require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-2021-06-03-new-study-paves-the-way-to-novel-treatment-for-triple-negative-breast-cancer-mcgill-university-health-centre-muhc-ca.json") })
        }
      }, "path---news-2021-06-03-new-study-paves-the-way-to-novel-treatment-for-triple-negative-breast-cancer-mcgill-university-health-centre-muhc-ca");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-2021-06-03-new-study-paves-the-way-to-novel-treatment-for-triple-negative-breast-cancer-mcgill-university-health-centre-muhc-ca!./.cache/json/news-2021-06-03-new-study-paves-the-way-to-novel-treatment-for-triple-negative-breast-cancer-mcgill-university-health-centre-muhc-ca.json
// module id = 472
// module chunks = 231608221292675